import { render, staticRenderFns } from "./EditBrandsForm.vue?vue&type=template&id=1cf87a1e&"
import script from "./EditBrandsForm.vue?vue&type=script&lang=js&"
export * from "./EditBrandsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports